import type { ReactNode } from "react";
import { formatDateHuman, type MatterRow } from "@themislex/shared";
import { Card, MatterStatusBadge } from "./ui";

/** Matter summary shared by the lawyer and client detail views. */
export function MatterInfoCard({
  matter,
  actions,
}: {
  matter: MatterRow;
  actions?: ReactNode;
}) {
  const rows: { label: string; value: ReactNode }[] = [
    { label: "Client", value: matter.clientName },
    { label: "Case type", value: matter.caseType },
    { label: "Case number", value: matter.caseNumber ?? "—" },
    { label: "Court / forum", value: matter.court ?? "—" },
    { label: "Next hearing", value: formatDateHuman(matter.nextHearingDate) },
    { label: "Status", value: <MatterStatusBadge status={matter.status} /> },
  ];

  return (
    <Card title={matter.title} actions={actions}>
      <dl className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
        {rows.map((row) => (
          <div key={row.label}>
            <dt className="text-xs font-semibold uppercase tracking-wide text-muted">
              {row.label}
            </dt>
            <dd className="mt-0.5 text-sm">{row.value}</dd>
          </div>
        ))}
      </dl>
      {matter.matterDescription && (
        <p className="mt-4 whitespace-pre-line border-t border-border pt-3 text-sm text-muted">
          {matter.matterDescription}
        </p>
      )}
    </Card>
  );
}
